import React from 'react';

const QuoteIcon = ({ color = 'black', size = 30, ...props }) => {
  return (
    <svg
      width={30}
      height={(size * 19) / 30}
      viewBox="0 0 30 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.9887 0.0609218C8.36846 -0.0993424 8.80221 0.0677357 8.99618 0.431436L9.82295 1.98161C10.0585 2.42325 9.8464 2.96626 9.39945 3.19157C8.57237 3.6085 7.95599 4.12121 7.55034 4.7297C7.08054 5.53507 6.84564 5.93775 6.84564 5.93775C6.84564 5.93775 7.18121 6.00486 7.85235 6.1391C8.52349 6.20621 9.26175 6.44111 10.0671 6.84379C10.9396 7.24647 11.7114 7.88406 12.3826 8.75654C13.0537 9.56191 13.3893 10.7029 13.3893 12.1794C13.3893 14.0586 12.7181 15.6693 11.3758 17.0116C10.1007 18.2867 8.55705 18.8908 6.74497 18.8237C4.86577 18.7565 3.25503 18.0183 1.91275 16.6089C0.637584 15.1324 0 13.3539 0 11.2733C0 8.65587 0.805369 6.34044 2.41611 4.32701C3.88365 2.43143 5.74118 1.0094 7.9887 0.0609218ZM24.5994 0.0609218C24.9792 -0.0993425 25.413 0.0677357 25.6069 0.431436L26.4337 1.98161C26.6692 2.42325 26.4571 2.96626 26.0102 3.19157C25.1831 3.6085 24.5667 4.12121 24.1611 4.7297C23.6913 5.53507 23.4564 5.93775 23.4564 5.93775C23.4564 5.93775 23.7919 6.00486 24.4631 6.1391C25.1342 6.20621 25.8725 6.44111 26.6779 6.84379C27.5503 7.24647 28.3221 7.88406 28.9933 8.75654C29.6644 9.56191 30 10.7029 30 12.1794C30 14.0586 29.3289 15.6693 27.9866 17.0116C26.7114 18.2867 25.1678 18.8908 23.3557 18.8237C21.4765 18.7565 19.8658 18.0183 18.5235 16.6089C17.2483 15.1324 16.6107 13.3539 16.6107 11.2733C16.6107 8.65587 17.4161 6.34044 19.0268 4.32701C20.4944 2.43143 22.3519 1.0094 24.5994 0.0609218Z"
        fill={color}
      />
    </svg>
  );
};

export default QuoteIcon;
